import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Aurora from "@/components/Aurora";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requirePaid = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-black relative grid place-items-center">
        <Aurora variant="subtle" />
        <div className="relative flex items-center gap-3 text-zinc-400">
          <Loader2 className="w-5 h-5 animate-spin text-cyan-300" />
          <span className="text-sm tracking-[0.25em] uppercase">Loading</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requirePaid && !user.has_paid) {
    return <Navigate to="/enroll" replace />;
  }

  return children;
}
